var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "result-box" },
    [
      _vm.lists && !_vm.lists.itemList.length && !_vm.firstTab
        ? _c("div", { staticClass: "beforeAjax" }, [_vm._v("暂无数据")])
        : _vm._e(),
      _vm._v(" "),
      _vm.firstTab
        ? _c(
            "div",
            { staticClass: "h-list flexBox", on: { click: _vm.viewAllDaily } },
            [
              _c("div", { staticClass: "q_title_item" }, [
                _vm._v("近期知识日报查看")
              ]),
              _vm._v(" "),
              !_vm.latestIsRead && _vm.$store.state.global.newDaily
                ? _c("img", {
                    staticClass: "q_title_icon",
                    attrs: { src: "/static/images/icon/NEW.svg" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "q_title_blank flexItem" }),
              _vm._v(" "),
              _c("div", { staticClass: "q_title_arrow" })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.lists && _vm.lists.itemList.length
        ? [
            _vm._l(_vm.lists.itemList, function(list, index) {
              return _c(
                "div",
                {
                  staticClass: "h-list",
                  attrs: { typeId: list.KBTypeId },
                  on: {
                    click: function($event) {
                      return _vm.viewDetail(list.KBTypeId, list.KBInfoId, list)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "q_title_item" }, [
                    _vm._v(_vm._s(list.Title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "analyse-info" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("validCount")(list.TotalViewCount)) +
                          "人浏览"
                      )
                    ]),
                    _vm._v(" "),
                    list.KBTypeId === 1 || list.KBTypeId === 2
                      ? _c("span", { staticClass: "ml-10" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("validCount")(list.TotalCollectionCount)
                            ) + "人收藏"
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm.lists.noMore
              ? _c("div", { staticClass: "load-more-box" }, [
                  _c("p", { staticClass: "noMore" }, [_vm._v("没有更多了")])
                ])
              : _c("loading-more")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-b6b57052", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-b6b57052","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/resultList2.vue
// module id = null
// module chunks = 